function decodeHtmlEntities(value) {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
}

function stripTags(value) {
  return value.replace(/<[^>]+>/g, '').trim();
}

function enhanceDescriptionContent(container) {
  promoteBoldParagraphsToHeadings(container);
  convertBrBulletParagraphsToLists(container);
  convertInlineBulletParagraphs(container);
  convertBulletParagraphGroupsToLists(container);
}

function promoteBoldParagraphsToHeadings(container) {
  container.querySelectorAll('p').forEach((paragraph) => {
    const strong = paragraph.querySelector(':scope > strong, :scope > b');
    if (!strong) return;

    const paragraphText = paragraph.textContent.replace(/\s+/g, ' ').trim();
    const strongText = strong.textContent.replace(/\s+/g, ' ').trim();
    if (!strongText || paragraphText !== strongText) return;

    const heading = document.createElement('h3');
    heading.innerHTML = strong.innerHTML;
    paragraph.replaceWith(heading);
  });
}

function convertBrBulletParagraphsToLists(container) {
  const bulletPattern = /^[\u2022\u2023\u2043\u2219•\-\*–—✔]\s*/;

  container.querySelectorAll('p').forEach((paragraph) => {
    if (paragraph.closest('ul, ol') || paragraph.querySelector('ul, ol')) return;

    const html = paragraph.innerHTML;
    if (!/<br\s*\/?>/i.test(html)) return;

    const parts = html
      .split(/<br\s*\/?>/i)
      .map((part) => part.trim())
      .filter(Boolean);

    if (parts.length < 2) return;

    const bulletParts = parts.filter((part) => {
      const text = stripTags(decodeHtmlEntities(part));
      return bulletPattern.test(text);
    });

    if (bulletParts.length < 2) {
      const firstPlain = stripTags(decodeHtmlEntities(parts[0]));
      const restAreBullets = parts.slice(1).every((part) =>
        bulletPattern.test(stripTags(decodeHtmlEntities(part)))
      );

      if (!bulletPattern.test(firstPlain) && restAreBullets && parts.length >= 3) {
        const heading = document.createElement('h3');
        heading.innerHTML = parts[0];
        const list = document.createElement('ul');

        parts.slice(1).forEach((part) => {
          const plainText = stripTags(decodeHtmlEntities(part));
          if (!plainText) return;
          const listItem = document.createElement('li');
          listItem.innerHTML = part.replace(bulletPattern, '');
          list.appendChild(listItem);
        });

        if (list.children.length >= 2) {
          const fragment = document.createDocumentFragment();
          fragment.appendChild(heading);
          fragment.appendChild(list);
          paragraph.replaceWith(fragment);
        }
      }
      return;
    }

    const list = document.createElement('ul');
    parts.forEach((part) => {
      const plainText = stripTags(decodeHtmlEntities(part));
      if (!plainText) return;

      const listItem = document.createElement('li');
      if (bulletPattern.test(plainText)) {
        listItem.innerHTML = part.replace(bulletPattern, '');
      } else {
        listItem.innerHTML = part;
      }
      list.appendChild(listItem);
    });

    if (list.children.length >= 2) {
      paragraph.replaceWith(list);
    }
  });
}

function convertInlineBulletParagraphs(container) {
  const bulletSplitPattern = /•|&bull;|&#8226;|&#x2022;/g;
  const bulletPattern = /^[\u2022\u2023\u2043\u2219•\-\*–—✔]\s*/;
  const benefitsPattern = /Benefits Based on Ingredients:?\s*$/i;

  container.querySelectorAll('p').forEach((paragraph) => {
    if (paragraph.closest('ul, ol') || paragraph.querySelector('ul, ol')) return;

    const html = paragraph.innerHTML;
    const bulletCount = (html.match(bulletSplitPattern) || []).length;
    if (bulletCount < 2) return;

    const parts = html
      .split(bulletSplitPattern)
      .map((part) => part.trim())
      .filter(Boolean);

    if (parts.length < 2) return;

    const fragment = document.createDocumentFragment();
    let listParts = parts;
    const introMatch = parts[0].match(benefitsPattern);

    if (introMatch) {
      const introText = parts[0].replace(benefitsPattern, '').trim();
      if (introText) {
        const intro = document.createElement('p');
        intro.innerHTML = introText;
        fragment.appendChild(intro);
      }

      const heading = document.createElement('h3');
      heading.textContent = 'Benefits Based on Ingredients';
      fragment.appendChild(heading);
      listParts = parts.slice(1);
    } else if (stripTags(decodeHtmlEntities(parts[0]))) {
      const intro = document.createElement('p');
      intro.innerHTML = parts[0];
      fragment.appendChild(intro);
      listParts = parts.slice(1);
    }

    const list = document.createElement('ul');
    listParts.forEach((part) => {
      const plainText = stripTags(decodeHtmlEntities(part));
      if (!plainText) return;

      const listItem = document.createElement('li');
      listItem.innerHTML = part.replace(bulletPattern, '');
      list.appendChild(listItem);
    });

    if (list.children.length < 2) return;

    fragment.appendChild(list);
    paragraph.replaceWith(fragment);
  });
}

function convertBulletParagraphGroupsToLists(container) {
  const bulletPattern = /^[\u2022\u2023\u2043\u2219•\-\*–—✔]\s*/;
  const children = Array.from(container.children);
  let index = 0;

  while (index < children.length) {
    const node = children[index];
    if (!isBulletParagraph(node, bulletPattern)) {
      index += 1;
      continue;
    }

    const items = [];
    while (index < children.length && isBulletParagraph(children[index], bulletPattern)) {
      items.push(children[index]);
      index += 1;
    }

    if (items.length < 2) continue;

    const list = document.createElement('ul');
    const firstItem = items[0];
    items.forEach((item) => {
      const listItem = document.createElement('li');
      listItem.textContent = item.textContent.replace(bulletPattern, '').trim();
      list.appendChild(listItem);
    });
    firstItem.replaceWith(list);
    items.slice(1).forEach((item) => item.remove());
  }
}

function isBulletParagraph(node, bulletPattern) {
  if (!node || node.tagName !== 'P') return false;
  return bulletPattern.test(node.textContent.trim());
}

function initDescriptionA11y(root) {
  const scope = root || document;
  scope.querySelectorAll('.description-accordion .collapsible__content').forEach((container) => {
    if (container.dataset.a11yEnhanced === 'true') return;
    enhanceDescriptionContent(container);
    container.dataset.a11yEnhanced = 'true';
  });
}

function bootDescriptionA11y() {
  initDescriptionA11y();

  document.querySelectorAll('.description-accordion .collapsible__title').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      window.setTimeout(() => initDescriptionA11y(toggle.closest('collapsible-element')), 350);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootDescriptionA11y);
} else {
  bootDescriptionA11y();
}
